import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=2a4cb06a&scoped=true"
import script from "./Error404.vue?vue&type=script&lang=js"
export * from "./Error404.vue?vue&type=script&lang=js"
import style0 from "./Error404.vue?vue&type=style&index=0&id=2a4cb06a&prod&lang=scss"
import style1 from "./Error404.vue?vue&type=style&index=1&id=2a4cb06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4cb06a",
  null
  
)

export default component.exports